import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Spin } from "antd";
import { useForm } from "react-hook-form";
import { InputField } from "../../../../atoms/FormFields";
import { CompanyListType } from "../../ducks/types";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  apiSubmit: () => void;
  loading: boolean;
  tableRecord: CompanyListType | null;
}

interface FormValues {
  deleteCompany: string;
}

export default function DeleteCompanyPopUp(props: PropsType) {
  const { onClose, tableRecord, apiSubmit, loading } = props;
  const {
    control,
    setError,
    formState: { errors, isDirty, isValid },
    handleSubmit,
  } = useForm<FormValues>();

  const onSubmit = (val: FormValues) => {
    if (val.deleteCompany?.toLowerCase() !== tableRecord?.name?.toLowerCase()) {
      setError("deleteCompany", {
        type: "manual",
        message: "Company name does not match.",
      });
      return;
    }
    apiSubmit();
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <Form
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        autoComplete="off"
        name="dependencies"
      >
        <div className="modalWrapper deleteModal">
          <div className="modal_header">
            <div className="title">
              <h3>
                <span>
                  <img src="/images/company/warning.svg" alt="warning" />
                </span>
                Company data will be erased
              </h3>
              <p>
                The company's user accounts, data, and history will be
                permanently deleted. This action cannot be undone.
              </p>

              <p>
                Think twice and consider
                <span
                  style={{
                    textDecoration: "underline",
                    paddingLeft: "3px",
                    paddingRight: "3px",
                  }}
                >
                  deactivating company
                </span>
                instead to preserve its data.
              </p>

              <p>
                Type{" "}
                <span style={{ fontWeight: "bold" }}>
                  {" "}
                  {tableRecord?.name}{" "}
                </span>{" "}
                in the field below to confirm deletion.
              </p>
            </div>
          </div>

          <div className="modal_content">
            <Row>
              <Col span={24}>
                <InputField
                  fieldName="deleteCompany"
                  label="Company name"
                  control={control}
                  className="mb-0"
                  iProps={{
                    placeholder: "Enter company name",
                  }}
                  isRequired
                  rules={{
                    required: "Company name is required.",
                  }}
                  validate={errors.deleteCompany && "error"}
                  validMessage={
                    errors.deleteCompany && errors.deleteCompany.message
                  }
                />
              </Col>
            </Row>
          </div>

          <div className="modal_footer">
            <Button
              htmlType="button"
              type="default"
              size="large"
              className="outlined-btn"
              onClick={onClose}
            >
              Cancel
            </Button>

            <Button
              htmlType="submit"
              type="primary"
              size="large"
              className="danger-btn"
              disabled={!isDirty || !isValid}
            >
              Delete company account
            </Button>
          </div>
        </div>
      </Form>
    </Spin>
  );
}
